import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const availableLanguages = {
  "en": "English",
  "hu": "Magyar",
}

const resources = {
  en: {
    translation: {
      "login": "Login",
      "username": "Username",
      "password": "Password",
      "email": "E-mail",
      "usernameOrEmail": "Username or e-mail",
      "loginButton": "Login",
      "dashboard": "Dashboard",
      "timetable": "Timetable",
      "dataUsage": "Data Usage",
      "outdoorTemperature": "Outdoor temperature",
      "outdoorHumidity": "Outdoor humidity",
      "quickSettings": "Temperature unification",
      "logOut": "Log out",
      "back": "Back",
      "selectRole": "Select your role",
      "loginWithRole": "Login with selected role",
      "role": "Role",
      "roles": {
        "admin": "Superadmin",
        "building_1": "Building",
        "ap_resident": "Owner"
      },
      "unSuccessful": "Hiba (kérlek probáld meg később)",
      "successfulForgotPassword": "We have sent an email to the email address you entered, please open the link in the email. You will then be able to enter your new password!",
      "successSave": "Saved",
      "connectionReady": "Connection OK",
      "connectionError": "Connection Error",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "ok": "OK",
      "sunny": "Sunny",
      "dehumidifier": "Dehumidifier",
      "newPassword": "New password",
      "newPasswordButton": "Request new password",
      "forgotPassword": "Elfelejtettem a jelszavam",
      "changeLanguage": "Change language",
      "all": "All",
      "setTemperatureAll": "Set temperature for all rooms",
      "humidity": "Humidity",
      "dewPoint": "Dew point",
      "childLock": "Child Lock",
      "mode": "Mode",
      "cooling": "Cooling",
      "heating": "Heating",
      "setTemperature": "Set Temperature",
      "btnInstall": "Install App",
      "downloadOverlayTitle": "Download the app:",
      "downloadOverlayStep1": 'Press the "Share" icon at the bottom centre.',
      "downloadOverlayStep2": 'Select the "Add to Home Screen" option.',
      "downloadOverlayLink": 'Click here, and watch the video to see how to install the app!',
      "currentMonth": "Current Month",
      "waterHeating": "Water Heating",
      "save": "Save",
      "inactive": "Inactive",
      "active": "Active",
      "cancel": "Cancel",
      "create": "Create",
      "send": "Send",
      "copy": "Copy",
      "delete": "Delete",
      "details": "Details",
      "loading": "Loading",
      "normal": "Normal",
      "safe": "Safe",
      "tilt": "Tilt",
      "on": "On",
      "off": "Off",
      "isSystemOn": "System on",
      "isSystemOff": "System off",
      "coolingDisabledDewPoint": "Cooling disabled",
      "coolingDisabledDewPointDescription": "Condensation expected. Wait until the humidity decreases, ventilate more!",
      "coolingDisabledWarning": "High humidity",
      "coolingDisabledWarningDescription": "Ventilate to avoid condensation!",
      "chooseApartmentTitle": "Select another apartment",
      "invalidCredentials": "Wrong e-mail or password",
      "missing parameter": " Required fields are missing from sent data",
      "user not found": "User not found, please ask it from your building owner",
      "invalid login level": "Requested login level is not among the user's available rights.",
      "invalid password": "Wrong password",
      "measuredTemperature": "Measured temperature",
      "passwordChange": {
        "title": "Change your password",
        "newPassword": "New password",
        "currentPassword": "Old password",
        "confirmPassword": "Confirm new password",
        "passwordsDoNotMatch": "Passwords are different",
        "passwordTooWeak": "The password must contain upper and lower case letters, a number and be at least 8 characters long",
        "passwordRequirement": "At least 8 characters, upper and lower case letters, and numbers required",
        "passwordStrong": "Password is strong",
        "passwordChangeFailed": "Password change failed",
        "passwordRequirements": "Password requirements",
        "passwordMinLength": "At least 8 characters",
        "passwordHasLowercase": "At least 1 lowercase character",
        "passwordHasUppercase": "At least 1 uppercase character",
        "passwordsMatch": "New password and confirmation are identical",
        "enterNewPassword": "Enter new password",
        "confirmNewPassword": "Confirm new password",
        "save": "Save"
      },
      "buildingSelector": {
        "btnTitle": "Select another apartment",
        "building": "Building",
        "selectBuilding": "Select a building",
        "selectApartmentTitle": "Select an apartment",
        "apartment": "Apartment",
        "selectApartment": "Select an apartment",
        "save": "Select",
        "saved": "Building and apartment saved!",
        "error": {
          "selectBoth": "Please select a building and an apartment!",
          "buildingLoad": "Error! No flat is assigned to you. Request access to your apartment!"
        }
      },
      "apartmentSelector": "Apartment selector",
      "subUsers": {
        "label": "Sub-users",
        "count": "{{count}} / {{max}} sub-users",
        "createNew": "Create new sub-user",
        "expiryLabel": "Set expiry time",
        "expiryDays": "Number of days",
        "expiryDaysPlaceholder": "e.g. 10",
        "expiryTime": "Time",
        "emptyState": "No sub-users created yet.",
        "emptyHint": "Click the \"+ Create\" button to add the first sub-user.",
        "expired": "Expired",
        "expiryUntil": "– until {{date}}",
        "credentialsTitle": "New sub-user created",
        "credentialsSubtitle": "Login credentials:",
        "emailSentTo": "Credentials sent by email to: {{email}}",
        "sendByEmail": "Send by email",
        "emailModalTitle": "Send email",
        "emailModalDesc": "Send login credentials to {{name}}:",
        "emailPlaceholder": "e.g. guest@email.com",
        "emailSentSuccess": "Email sent successfully!",
        "emailSentError": "Error sending email.",
        "sending": "Sending...",
        "existingUserTitle": "User added to apartment",
        "existingUserNote": "This user already exists in the system. They have been added to the apartment."
      },
      "close": "Close",
      "enableNotifications": "Enable notifications",
      "dehumidifierStatus": "Dehumidifier status",
      "temperatureUnit": "Temperature unit",
      "error": {
        "loadingFailed": "Failed to load data",
        "savingFailed": "Failed to save settings"
      },
      "dataUsageModalInfos": {
        "forwardWaterTemperature": "Forward water temperature",
        "returnWaterTemperature": "Return water temperature",
        "heatingCoolingVolumeMeter": "Heating/cooling volume meter",
        "forwardWaterTemperatureDescription": "The temperature of hot water coming from the boiler/heat center to the radiators. This value shows how hot water the heating system receives.",
        "returnWaterTemperatureDescription": "The temperature of water returning from the radiators. This value shows how much the water has cooled down by the time it returns from the apartment radiators to the boiler/heat center.",
        "heatingCoolingVolumeMeterDescription": "The amount of water used for heating that flows through the pipes. It shows how much water moved in the system during a given time period."
      },
      "messages": "Messages",
      "messagesLimit": "Showing the last {{count}} messages from the past 3 months.",
      "statistic": "Statistic",
      "settings": "Settings",
      "hasBuildingChildLock": "Building child lock is set: ",
      "buildingDisabled": "System is disabled at building level",
      "weather": {
        "sunny": "sunny",
        "clearNight": "clear night",
        "partlyCloudy": "partly cloudy",
        "cloudy": "cloudy",
        "rainy": "rainy",
        "heavyRain": "heavy rain",
        "snow": "snow",
        "windy": "windy"
      },
    },
  },
  hu: {
    translation: {
      "login": "Bejelentkezés",
      "username": "Felhasználónév",
      "usernameOrEmail": "Felhasználónév vagy e-mail",
      "password": "Jelszó",
      "email": "E-mail",
      "loginButton": "Bejelentkezés",
      "dashboard": "Otthon",
      "timetable": "Időbeosztás",
      "dataUsage": "Statisztika",
      "outdoorTemperature": "Külső hőmérséklet",
      "outdoorHumidity": "Külső páratartalom",
      "quickSettings": "Hőmérséklet egységesítés",
      "logOut": "Kijelentkezés",
      "back": "Vissza",
      "selectRole": "Több szerepköröd van. Válaszd ki melyikkel szeretnél belépni!",
      "loginWithRole": "Bejelentkezés ezzel a szerepkörrel",
      "role": "Választás",
      "on": "Be",
      "off": "Ki",
      "isSystemOn": "Rendszer bekapcsolva",
      "isSystemOff": "Rendszer kikapcsolva",
      "coolingDisabledDewPoint": "Hűtés letiltva",
      "coolingDisabledDewPointDescription": "Párakicsapódás várható. Várj, amíg csökken a páratartalom, szellőztess többet!",
      "coolingDisabledWarning": "Magas páratartalom",
      "coolingDisabledWarningDescription": "Szellőztess, hogy elkerüld a párakicsapodást!",
      "roles": {
        "admin": "Szuperadmin",
        "building_1": "Beruházó képviselő",
        "ap_resident": "Bérlő",
        "ap_owner": "Tulajdonos"
      },
      "unSuccessful": "Hiba (kérlek probáld meg később)",
      "successSave": "Sikeres Mentés ",
      "connectionReady": "Kapcsolat rendben",
      "connectionError": "Kapcsolat hiba",
      "connected": "Kapcsolódva",
      "ok": "Rendben",
      "disconnected": "Nincs kapcsolat",
      "dehumidifier": "Légszáritó állapota (tiltva/engedélyezve)",
      "newPassword": "Új jelszó",
      "newPasswordButton": "Új jelszó kérése",
      "forgotPassword": "Elfelejtett jelszó",
      "successfulForgotPassword": "Ha létezik az e-mail cím, kiküldtünk egy levelet! Kérlek nyisd meg a benne található linket. A megnyiló weboldalon megtudod adni az új jelszavad!",
      "changeLanguage": "Nyelv választása",
      "all": "Összes",
      "setTemperatureAll": "Hőmérséklet beállítása minden szobára",
      "humidity": "Páratartalom",
      "dewPoint": "Harmatpont",
      "childLock": "Gyerekzár",
      "mode": "Üzemmód",
      "cooling": "Hűtés",
      "heating": "Fűtés",
      "setTemperature": "Állítsd be az összes szobát ugyanarra a hőmérsékletre.",
      "btnInstall": "Alkalmazás telepítése",
      "downloadOverlayTitle": "Az alkalmazás letöltése:",
      "downloadOverlayStep1": 'Nyomd meg a "Megosztás" ikont alul középen.',
      "downloadOverlayStep2": 'Válaszd a "Hozzáadás a Kezdőképernyőhöz" opciót.',
      "downloadOverlayLink": 'Kattints ide, és nézd meg, hogyan telepítheted az alkalmazást!',
      "currentMonth": "Aktuális hónap",
      "waterHeating": "Melegvíz észítés",
      "save": "Mentés",
      "active": "Aktív",
      "inactive": "Inaktív",
      "cancel": "Mégse",
      "create": "Létrehozás",
      "send": "Küldés",
      "copy": "Másolás",
      "delete": "Törlés",
      "details": "Részletek",
      "loading": "Betöltés",
      "normal": "Normal",
      "safe": "Biztonságos",
      "tilt": "Dőlt",
      "invalidCredentials": "Hibás e-mail cím vagy jelszó",
      "missing parameter": "Hiányzó paraméter",
      "user not found": "A felhasználó nem található, kérlek kérj hozzáférést a közös képviselődtől",
      "invalid login level": "A kért jogosultsági szint nem elérhető számodra",
      "invalid password": "Hibás jelszó",
      "chooseApartmentTitle": "Másik lakás választás",
      "measuredTemperature": "Mért hőmérséklet",
      "passwordChange": {
        "title": "Jelszó megváltoztatása",
        "newPassword": "Új jelszó",
        "currentPassword": "Régi jelszó",
        "confirmPassword": "Új jelszó megerősítése",
        "passwordsDoNotMatch": "A jelszavak nem egyeznek",
        "passwordTooWeak": "A jelszónak tartalmaznia kell kis- és nagybetűt, számot, és legalább 8 karakter hosszúnak kell lennie",
        "passwordRequirement": "Legalább 8 karakter, kis- és nagybetű, valamint szám szükséges",
        "passwordStrong": "A jelszó megfelelő",
        "passwordChangeFailed": "A jelszó módosítása nem sikerült",
        "passwordRequirements": "Jelszó követelmények",
        "passwordMinLength": "Legalább 8 karakter",
        "passwordHasLowercase": "Legalább 1 kisbetűs karakter",
        "passwordHasUppercase": "Legalább 1 nagybetűs karakter",
        "passwordsMatch": "Új jelszó és megerősítés azonos",
        "enterNewPassword": "Adja meg az új jelszót",
        "confirmNewPassword": "Erősítse meg az új jelszót",
        "save": "Mentés"
      },
      "buildingSelector": {
        "btnTitle": "Másik lakás választása",
        "building": "Épület",
        "selectApartmentTitle": "Válaszd ki a lakásodat",
        "selectBuilding": "Válassz épületet",
        "apartment": "Lakás",
        "selectApartment": "Válassz lakást",
        "save": "Választás",
        "saved": "Az épület és a lakás elmentve!",
        "error": {
          "selectBoth": "Válassz ki egy épületet és egy lakást!",
          "buildingLoad": "Hiba! Még nincs lakás hozzád rendelve. Kérlek, igényelj hozzáférést a lakásodhoz!"
        }
      },
      "apartmentSelector": "Lakás választó",
      "subUsers": {
        "label": "Családtagok, Albérlők",
        "count": "{{count}} / {{max}} albérlő, családtag",
        "createNew": "Új létrehozása",
        "expiryLabel": "Érvényességi idő megadása",
        "expiryDays": "Napok száma",
        "expiryDaysPlaceholder": "pl. 10",
        "expiryTime": "Időpont",
        "emptyState": "Még nincs lakó létrehozva.",
        "emptyHint": 'Kattints a "+ Létrehozás" gombra az első lakó hozzáadásához.',
        "expired": "Lejárt",
        "expiryUntil": "– {{date}}-ig",
        "credentialsTitle": "Új lakó létrehozva",
        "credentialsSubtitle": "Az alábbi adatokkal tud bejelentkezni:",
        "emailSentTo": "Az adatok elküldve e-mailben: {{email}}",
        "sendByEmail": "Küldés e-mailben",
        "emailModalTitle": "E-mail küldése",
        "emailModalDesc": "A belépési adatok elküldése {{name}} részére:",
        "emailPlaceholder": "pl. vendeg@email.hu",
        "emailSentSuccess": "E-mail sikeresen elküldve!",
        "emailSentError": "Hiba az e-mail küldésekor.",
        "sending": "Küldés...",
        "existingUserTitle": "Felhasználó hozzáadva",
        "existingUserNote": "Ez a felhasználó már létezik a rendszerben. Hozzárendelve a lakáshoz."
      },
      "close": "Bezárás",
      "enableNotifications": "Értesítések engedélyezése",
      "dehumidifierStatus": "Légszárító állapota",
      "temperatureUnit": "Mértékegység",
      "error": {
        "loadingFailed": "Az adatok betöltése sikertelen",
        "savingFailed": "A beállítások mentése sikertelen"
      },
      "dataUsageModalInfos": {
        "forwardWaterTemperature": "Előremenő víz hőmérséklete",
        "returnWaterTemperature": "Visszatérő víz hőmérséklete",
        "heatingCoolingVolumeMeter": "Átfolyt vízmennyiség",
        "forwardWaterTemperatureDescription": "A kazánból / hőközpontból érkező meleg víz hőmérséklete, ami a fűtőtestekhez jut. Ez az érték megmutatja, hogy, mennyire meleg vizet kap a fűtési rendszer.",
        "returnWaterTemperatureDescription": "A fűtőtestekből visszaérkező víz hőmérséklete. Ez az érték megmutatja, hogy mennyire hűlt le a víz, mire visszaért a lakás fűtőtesteiből a kazánhoz / hőközponthoz.",
        "heatingCoolingVolumeMeterDescription": "A fűtéshez felhasznált, a csöveken átáramló víz mennyisége. Megmutatja, hogy mennyi víz mozgott a rendszerben adott idő alatt.",      
      },
      "messages": "Üzenetek",
      "messagesLimit": "Az elmúlt 3 hónap legfeljebb {{count}} üzenete jelenik meg.",
      "statistic": "Statisztika",
      "settings": "Beállítások",
      "buildingDisabled": "Épület szinten a rendszer kikapcsolva",
      "hasBuildingChildLock": "Épület szintű célhőmérséklet beállítva: ",
      "weather": {
        "sunny": "napos",
        "clearNight": "holdas",
        "partlyCloudy": "részben felhős",
        "cloudy": "felhős",
        "rainy": "esős",
        "heavyRain": "intenzív eső",
        "snow": "havazás",
        "windy": "szeles"
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'hu',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});

export default i18n;
